<figure class="tt-c-comments-pin">
  <div class="tt-c-comments-pin__image-wrapper" @mouseover="onShowActions" @mouseout="onHideActions">
    <a :href="productLink" target="_blank"
       @focus="onShowActions"
       @blur="onHideActions"
       class="tt-c-comments-pin__item-link tt-u-ignore-default"
       :title="$msg('commentsPinboardItem.goToPageForProduct', [item.title])"
       tabindex="0"
       rel="nofollow">
      <tt-product-image ref="productImage" class="tt-c-comments-pin__image" :catItem="item" :includeAlt="false" size="L"></tt-product-image>
      <div v-if="!isOnMobile" class="tt-c-comments-pin__product-info" :class="{ 'tt-c-comments-pin__product-info--hover': showActions }">
        <span class="tt-c-comments-pin__hover-product-name" v-html="hoverTitle"></span>
        <tt-rating-stars v-if="displayReviewStars" :rating="item.averageRating" class="tt-c-comments-pin__rating tt-c-rating--knockout"></tt-rating-stars>
      </div>
    </a>
    <div v-if="!isOnMobile" class="tt-c-comments-pin-actions" :class="{ 'tt-c-comments-pin-actions--hover': showActions }">
      <div v-if="showSocialSharing" class="tt-c-comments-pin-actions__group">
        <div role="button" class="tt-c-comments-pin-actions__icon tt-c-comments-pin-actions__icon--facebook"
            @click.prevent="openFacebookWindow"
            @keydown.enter.prevent="openFacebookWindow"
            @focus="onShowActions"
            @blur="onHideActions"
            :aria-label="$msg('commentsPinboardItem.shareOnFacebook')"
            tabindex="0"><tt-icon name="social-facebook"></tt-icon></div>
        <div role="button" class="tt-c-comments-pin-actions__icon tt-c-comments-pin-actions__icon--twitter"
            @click.prevent="openTwitterWindow"
            @keydown.enter.prevent="openTwitterWindow"
            @focus="onShowActions"
            @blur="onHideActions"
            :aria-label="$msg('commentsPinboardItem.shareOnTwitter')"
            tabindex="0"><tt-icon name="social-twitter"></tt-icon></div>
        <div role="button" class="tt-c-comments-pin-actions__icon tt-c-comments-pin-actions__icon--pinterest"
            @click.prevent="openPinterestWindow"
            @keydown.enter.prevent="openPinterestWindow"
            @focus="onShowActions"
            @blur="onHideActions"
            :aria-label="$msg('commentsPinboardItem.shareOnPinterest')"
            tabindex="0"><tt-icon name="social-pinterest"></tt-icon></div>
      </div>
    </div>
  </div>
  <span class="tt-c-comments-pin__product-name" v-html="title"></span>
  <tt-pinboard-comment v-for="comment in commentsForDisplay"
                       @expanded="commentExpanded"
                       :comment="comment"
                       :commentMaxLength="commentMaxLength"
                       :userNameMaxLength="userNameMaxLength"
                       :key="comment.id"></tt-pinboard-comment>
  <a v-if="seeMoreText" :href="productLink" target="_blank" class="tt-c-comments-pin__cta tt-u-ignore-default" rel="nofollow"><span class="tt-c-comments-pin__cta-text" v-html="seeMoreText"></span><tt-icon name="caret-right" class="tt-c-comments-pin__cta-arrow" size="sm"></tt-icon></a>
</figure>
